import { Link } from 'react-router-dom';

const TabNavigation = ({ activeTab, onTabChange, tabs }) => {
  return (
    <div className="tab-navigation">
      <div className="tab-nav-container">
        {tabs.map((tab) => (
          <Link
            key={tab.id}
            to={tab.path || `/${tab.id === 'home' ? '' : tab.id}`}
            className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => onTabChange(tab.id)}
          >
            <span className="tab-icon">{tab.icon}</span>
            <span className="tab-label">{tab.label}</span>
            {tab.badge && <span className="tab-badge">{tab.badge}</span>}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default TabNavigation;
